import React from 'react';
import moment from 'moment';
import classnames from 'classnames';
import ReactHtmlParser from 'react-html-parser';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';
import { Translate, withLocalize } from 'react-localize-redux';
import { Circles } from '../common/loadingComponent';
import { REGISTRY } from '../../store/ceeSearchStore';
import { popupActions } from '../../store/popupStore';
import { layoutActions } from '../../store/layoutStore';
import { domainActions } from '../../store/domainStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { monitoringActions } from '../../store/monitoringStore';
import { getHostApi, apiPost, apiGet, hasPermission } from '../../store/apiWrapper';
import Message from '../common/message';
import MoreButton from '../layoutItems/moreButton';
import NoDataComponent from '../common/noDataComponent';
import ResponsiveTable from '../layoutItems/responsiveTable';
import { PORTFOLIO_TYPES } from './monitoringConstants';

import Aml from '../../img/icons/leftPanel/BBiconsBmAml';
import Cre from '../../img/icons/leftPanel/BBiconsBmExekuceSk';
import Cee from '../../img/icons/leftPanel/BBiconsBmExekuceCz';
import Insolvency from '../../img/icons/leftPanel/BBiconsBmReportKonfliktuZajmu';
import Download from '../../img/icons/BBicons_Stahnout';
import Remove from '../../img/icons/BBiconsOdstranit';
import Edit from '../../img/icons/Upravit';

import './monitoring.scss';

class PortfolioOverview extends React.Component {
    mounted = false;

    state = {
        portfolios: { loading: false, error: null, data: null, subjectsExportExcelMax: null, subjectsExportCsvMax: null },
        isLoading: false,
        succRemoveMessage: null,
        succOperationMessage: false,
        error: null,
    };

    render() {
        if (this.state.portfolios.loading || this.state.isLoading)
            return <Circles />;
        if (!this.state.portfolios)
            return <NoDataComponent />;

        return (
            <>
                <div className="error-container error-container-wide card-special">
                    {this.state.portfolios.error && <Message type='error' message={this.state.portfolios.error} />}
                    {this.state.succRemoveMessage && <Message type="success" message={this.props.translate("Monitoring.SuccessRemovePortfolio").replace('{0}', this.state.succRemoveMessage)}></Message>}
                    {this.state.succOperationMessage && <Message type="success" message={this.props.translate("Monitoring.SuccessOperation").replace('{0}', this.state.succOperationMessage)}></Message>}
                    {this.state.error && this.state.error.exception && <Message type="error" options={{ renderInnerHtml: true }}
                        message={this.props.translate(this.state.error.exception, this.getExceptionData(this.state.error.exceptionData))}
                    />}
                </div>
                <div className='hide-on-mobile card card-special'>
                    <div className='card-body card-body-fill'>
                        <ResponsiveTable>
                            <table className='table table-report-section table-centered'>
                                <thead>
                                    <tr>
                                        <th><Translate id="Monitoring.Overview.Name" /></th>
                                        <th><Translate id="Monitoring.Overview.Type" /></th>
                                        <th className='align-right rpad'><Translate id="Monitoring.Overview.SubjectCount" /></th>
                                        <th><Translate id="Monitoring.Overview.Monitoring" /></th>
                                        <th colSpan="4" className='align-right' width="10%"><Translate id="Common.Actions" /></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.portfolios.data && this.state.portfolios.data.map(
                                        (r) => {
                                            return <tr className='colorize' key={r.id}>
                                                <td data-label={this.props.translate("Monitoring.Overview.Name")}>
                                                    {!isNullOrUndefined(r.parentId) && <>
                                                        <span title={this.props.translate("Portfolio.1stLevel")}><FontAwesomeIcon icon="arrow-right" /></span>&nbsp;
                                                    </>}
                                                    <Link className={classnames('link-functional', { 'is-normal': localStorage.locales_url_format === 'normal', 'hide-on-mobile': !this.props.showOnMobile })} to={{ pathname: `/monitoring/alerts/${r.id}` }}>
                                                        {r.name}
                                                    </Link>
                                                </td>
                                                <td data-label={this.props.translate("Monitoring.Overview.Type")}>
                                                    <span>{ReactHtmlParser(r.type.replace("<br />", " - "))}</span>
                                                    <sup>{r.marketingCountry}</sup>
                                                </td>
                                                <td className='align-right rpad'
                                                    data-label={this.props.translate("Monitoring.Overview.SubjectCount")}
                                                >
                                                    <span>
                                                        {r.subjects}
                                                    </span>
                                                </td>
                                                <td data-label={this.props.translate("Monitoring.Overview.Monitoring")}>
                                                    <span>
                                                        {r.isMonitored ?
                                                            <Translate id="Monitoring.Overview.Active" /> :
                                                            <Translate id="Monitoring.Overview.Inactive" />
                                                        }
                                                    </span>
                                                </td>
                                                {this.renderButtons(r, false)}
                                                <td>
                                                    <span>
                                                        {r.portfolioType !== PORTFOLIO_TYPES.cadastreSk && this.renderButtonMore(r)}
                                                    </span>
                                                </td>
                                            </tr>
                                        })
                                    }
                                </tbody>
                            </table>
                        </ResponsiveTable>
                        <div className='port-new-btn m-top'>
                            {this.renderCreateNewPortfolioBtn()}
                        </div>
                    </div>
                </div>
                <div className='hide-on-desktop sr-result-list'>
                    <div className='table sr-table'>
                        {this.state.portfolios.data && this.state.portfolios.data.map(
                            (r, i) => {
                                return <div key={i} className='sr-result'>
                                    <div className='port-result'>
                                        <div className='port-result-header'>
                                            <div>
                                                <span className="bold">{this.props.translate("Monitoring.Overview.Name")}:&nbsp;</span>
                                                {!isNullOrUndefined(r.parentId) && <>
                                                    <span title={this.props.translate("Portfolio.1stLevel")}><FontAwesomeIcon icon="arrow-right" /></span>&nbsp;
                                                </>}
                                                <Link className='link-functional' to={{ pathname: `/monitoring/alerts/${r.id}` }}>
                                                    {r.name}
                                                </Link>
                                            </div>
                                            <span className="bold">{this.props.translate("Monitoring.Overview.SubjectCount")}:&nbsp;{r.subjects}</span>
                                        </div>
                                        <div>
                                            <span className="bold">{this.props.translate("Monitoring.Overview.Type")}:&nbsp;</span>
                                            <span>{ReactHtmlParser(r.type.replace("<br />", " - "))}</span>
                                            <sup>{r.marketingCountry}</sup>
                                        </div>
                                        <div className='port-result-btns'>
                                            {this.renderButtons(r, true)}
                                            {this.renderButtonMore(r)}
                                        </div>
                                    </div>
                                </div>
                            }
                        )}
                    </div>
                    <div className='port-new-btn m-bottom'>
                        {this.renderCreateNewPortfolioBtn()}
                    </div>
                </div>
            </>
        )
    }

    componentDidMount() {
        this.mounted = true;
        this.fetchPortfolios();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.activeLanguage && prevProps.activeLanguage.code !== this.props.activeLanguage.code) {
            this.fetchPortfolios();
        }
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    renderButtons = (d, isMobile) => {
        const buttons = [
            {
                condition: (r) => r.subjects > 0 && (r.subjects <= this.state.portfolios.subjectsExportExcelMax || r.subjects <= this.state.portfolios.subjectsExportCsvMax),
                link: (r) => <a className='link-internal' onClick={() => this.createDownload(r.id, r.subjects)}>
                    {this.getIcon('download')}
                    <Translate id="Monitoring.Overview.Download" />
                </a>
            },
            {
                condition: () => true,
                link: (r) => <Link className='link-internal' to={`/monitoring/editPortfolio/${r.id}`}>
                    {this.getIcon('edit')}
                    <Translate id="Common.Button.Edit" />
                </Link>
            },
            {
                condition: (r) => (r.parentId === null || r.portfolioType !== PORTFOLIO_TYPES.cadastreSk),
                link: (r) => <a className='link-internal' onClick={() => this.deletePorfolioConfirm(r.id, r.name)}>
                    {this.getIcon('remove')}
                    <Translate id="Common.Button.Delete" />
                </a>
            }
        ]

        if (!isMobile) {
            return (
                <>
                    {buttons.map((b, i) => <td key={i} className='align-right'>
                        {b.condition(d) && <span className="m-right-btn">
                            <div className="ml-link color">
                                <div className="ml-link-inner">
                                    {b.link(d)}
                                </div>
                            </div>
                        </span>}
                    </td>)}
                </>
            )
        }

        return (
            <div className='port-result-btns-row'>
                {buttons.map((b, i) => b.condition(d) && <span key={i} className="m-right-btn">
                    <div className="ml-link color">
                        <div className="ml-link-inner">
                            {b.link(d)}
                        </div>
                    </div>
                </span>)}
            </div>
        )
    }

    renderButtonMore = (r) => {
        return (
            <MoreButton mode="rightAligned" contentWidth={325} id={`pm-${r.requestId}`}>
                <div className="port-result-btn-more">
                    {(((r.portfolioType === PORTFOLIO_TYPES.companyCz || r.portfolioType === PORTFOLIO_TYPES.companySk) &&
                        hasPermission(null, "CompanyAMLInfo")) || ((r.portfolioType === PORTFOLIO_TYPES.personCz || r.portfolioType === PORTFOLIO_TYPES.personSk) && hasPermission(null, "PersonAMLInfo"))) && isNullOrUndefined(r.parentId) &&
                        this.createCheckButton(this.props.translate("Monitoring.Common.CheckAML"), "aml",
                            () => this.checkCreditAml(r.id, r.subjects, r.portfolioType), !hasPermission(null, "AMLbulk") || isNullOrUndefined(r.subjects) || r.subjects < 1)}
                    {r.portfolioType !== PORTFOLIO_TYPES.cadastreSk && this.createCheckButton(this.props.translate("Monitoring.Common.CheckInsolvency"), "insolvency",
                        () => this.props.history.push(`/search/conflictOfInterest?portfolioId=${r.id}`),
                        !hasPermission(null, "ReferenceListConflict") || isNullOrUndefined(r.subjects) || r.subjects < 1)}
                    {r.portfolioType !== PORTFOLIO_TYPES.cadastreSk && r.marketingCountry === "SK" && isNullOrUndefined(r.parentId) && this.createCheckButton(
                        this.props.translate("Monitoring.Common.CheckCRE"),
                        "cre",
                        () => this.createCeeCreMonetaryObligationPopup(r.id, r.subjects, "cre"),
                        !hasPermission(null, "CREBulk") || (r.portfolioType !== PORTFOLIO_TYPES.companySk && r.portfolioType !== PORTFOLIO_TYPES.personSk) || r.subjects < 1
                    )}
                    {r.portfolioType !== PORTFOLIO_TYPES.cadastreSk && r.marketingCountry === "SK" && isNullOrUndefined(r.parentId) && this.createCheckButton(
                        this.props.translate("Monitoring.Common.CheckRPVE"),
                        "cre",
                        () => this.checkCreditExec(r.id, r.subjects, "rpve", {}),
                        !hasPermission(null, "RPVEBulk") || (r.portfolioType !== PORTFOLIO_TYPES.companySk && r.portfolioType !== PORTFOLIO_TYPES.personSk) || r.subjects < 1
                    )}
                    {r.marketingCountry === "CZ" && isNullOrUndefined(r.parentId) && this.createCheckButton(
                        this.props.translate("Monitoring.Common.CheckCEE"),
                        "cee",
                        () => this.createCeeCreMonetaryObligationPopup(r.id, r.subjects, "cee"),
                        !hasPermission(null, "CEEBulk") || (r.portfolioType !== PORTFOLIO_TYPES.companyCz && r.portfolioType !== PORTFOLIO_TYPES.personCz) || r.subjects < 1
                    )}
                </div>
            </MoreButton>
        );
    }

    createDownload(portfolioId, subjectsCount) {
        if (subjectsCount <= this.state.portfolios.subjectsExportExcelMax)
            window.open(`/files/portfolio/subjects/${portfolioId}`, "_blank");
        else if (subjectsCount <= this.state.portfolios.subjectsExportCsvMax)
            apiPost(getHostApi() + `/api/portfolio/${portfolioId}/subjects/exportCsv`, undefined, this.props.activeLanguage.code);
    }

    renderCreateNewPortfolioBtn = () => {
        return (
            <button
                className={classnames('bb-button bold-bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                onClick={_ => this.props.history.push('/monitoring/newPortfolio')}>
                <Translate id="Monitoring.Overview.CreateNewPortfolio" />
            </button>
        );
    }

    createCheckButton = (caption, icon, onClick, disabled = false, wait = false, href = null) => {
        return (
            <div className={`ml-link${disabled ? " disabled" : ""}`} onClick={disabled ? undefined : onClick} style={{ display: "flex" }}>
                {wait ? <FontAwesomeIcon icon='cog' spin /> :
                    <div className="center-content vertical">
                        {this.getIcon(icon)}
                        {isNullOrUndefined(href) ? <span className="ml-link-caption">{caption}</span> : <a download className="ml-link-caption" href={href}>{caption}</a>}
                    </div>}
            </div>
        )
    }

    getIcon(type) {
        switch (type) {
            case 'aml':
                return <Aml className="ml-link-icon" />;
            case 'cee':
                return <Cee className="ml-link-icon" />;
            case 'cre':
                return <Cre className="ml-link-icon" />;
            case 'insolvency':
                return <Insolvency className="ml-link-icon" />
            case 'download':
                return <Download className="ml-link-icon" />
            case 'remove':
                return <Remove className="ml-link-icon" />
            case 'edit':
                return <Edit className="ml-link-icon" />
            default:
                return null;
        }
    }

    checkCreditAml = (id, count, type) => {
        this.setState({ isLoading: true });
        let isCompany = type === PORTFOLIO_TYPES.companyCz || type === PORTFOLIO_TYPES.companySk;
        apiPost(`${getHostApi()}/api/portfolio/${id}/bulk/aml/check`, null, {},
            (s) => {
                if (s.data.isSuccess) {
                    var amlAccountInfo = {
                        accountType: s.data.accountType,
                        currency: s.data.currency,
                        amount: s.data.amount,
                        amountFormatted: s.data.amountFormatted,
                        disponibleAmount: s.data.disponibleAmount,
                        disponibleAmountFormatted: s.data.disponibleAmountFormatted,
                        reservedAmount: s.data.reservedAmount,
                        numCauses: isCompany ? count : 0,
                        numSearches: isCompany ? 0 : count,
                        isSuccess: true
                    }
                    this.setState({ isLoading: false, error: null });
                    this.props.showPopup('porfolioBulkConfirmation', {
                        open: true,
                        close: () => this.props.hidePopup(),
                        yes: (amlForceNew, allowCustomer) => {
                            this.props.hidePopup();
                            this.createAmlBulkRequest(id, !amlForceNew, allowCustomer);
                        },
                        formData: {},
                        registry: "aml",
                        bulkCheck: amlAccountInfo
                    });
                } else
                    this.onError(s.data.exception, s.data.exceptionData);
            },
            (e) => this.onError(e.data.error.message || "Common.Error")
        );
    }

    createAmlBulkRequest = (id, forceNew, allowCustomer) => {
        this.setState({ isLoading: true });
        apiPost(`${getHostApi()}/api/portfolio/${id}/bulk/aml`, null, { forceNew: forceNew, allowCustomer: allowCustomer },
            (s) => {
                if (s.data.isSuccess)
                    this.setState({ isLoading: false, succOperationMessage: this.props.translate("LeftPanel.Aml"), error: null });
                else
                    this.onError(s.data.exception, s.data.exceptionData);
            },
            (e) => this.onError(e.data.error.message || "Common.Error")
        );
    }


    createCeeCreMonetaryObligationPopup = (id, count, registry) => {
        this.props.showPopup('porfolioBulkCeeCreMonetaryObligation', {
            open: true,
            close: () => this.props.hidePopup(),
            search: (data) => {
                this.props.hidePopup();
                this.checkCreditExec(id, count, registry, data);
            },
            formData: {},
            registry: registry,
        });
    }

    checkCreditExec = (id, count, registry, causesData) => {
        this.setState({ isLoading: true });
        apiGet(`${getHostApi()}/api/portfolio/${id}/bulk/exec/check/${registry}`, { maxDetails: causesData.maxCauses },
            (s) => {
                if (s.data.isSuccess) {
                    var accountInfo = {
                        accountType: s.data.accountType,
                        currency: s.data.currency,
                        amount: s.data.amount,
                        amountFormatted: s.data.amountFormatted,
                        disponibleAmount: s.data.disponibleAmount,
                        disponibleAmountFormatted: s.data.disponibleAmountFormatted,
                        reservedAmount: s.data.reservedAmount,
                        numCauses: 0,
                        numSearches: count,
                        maxCauses: causesData.maxCauses,
                        showMonetaryRow: causesData.includeMonetary,
                        isSuccess: true
                    }
                    this.setState({ isLoading: false, error: null });
                    this.props.showPopup('porfolioBulkConfirmation', {
                        open: true,
                        close: () => this.props.hidePopup(),
                        yes: (amlForceNew, allowCustomer) => {
                            this.props.hidePopup();
                            this.createExecBulkRequest(id, registry, causesData);
                        },
                        formData: {},
                        registry: registry,
                        bulkCheck: accountInfo
                    });
                } else
                    this.onError(s.data.exception, s.data.exceptionData);
            },
            (e) => this.onError(e.data.error.message || "Common.Error")
        );
    }

    createExecBulkRequest = (id, registry, causesData) => {
        this.setState({ isLoading: true });
        var inputData = {};

        if (!isNullOrUndefined(causesData) && causesData.includeMonetary) {

            let executionDate = registry === REGISTRY.cee ? causesData.minCauseDate === '' ? null : moment(causesData.minCauseDate).format() :
                (isNullOrUndefined(causesData.year) || causesData.year === '') ? null : moment(new Date(parseInt(causesData.year), 0, 1, 0, 0, 0, 0)).format();

            inputData = {
                maxDetails: causesData.maxCauses === "" ? null : causesData.maxCauses,
                maxExecutions: causesData.maxTotalCauses === "" ? null : causesData.maxTotalCauses,
                dateExecutionFrom: executionDate,
                priceFrom: registry === REGISTRY.cee ? causesData.minCauseAmount === "" ? null : causesData.minCauseAmount : null
            }
        }

        apiPost(`${getHostApi()}/api/portfolio/${id}/bulk/exec/${registry}`, null, inputData,
            (s) => {
                if (s.data.isSuccess) {
                    this.setState({ isLoading: false, succOperationMessage: this.props.translate(`LeftPanel.${s.data.isCre === true ? 'Cre' : 'Cee'}`), error: null });
                }
                else
                    this.onError(s.data.exception, s.data.exceptionData);
            },
            (e) => this.onError(e.data.error.message || "Common.Error")
        );
    }

    fetchPortfolios = () => {
        if (!this.mounted)
            return;
        this.setState(state => ({ portfolios: { ...state.portfolios, ...{ loading: true, error: null, data: null } } }));
        apiPost(`${getHostApi()}/api/portfolio/list`, null, {},
            (s) => {
                if (s.data.isSuccess)
                    this.setState(state => ({ portfolios: { ...state.portfolios, loading: false, data: s.data.items, subjectsExportExcelMax: s.data.subjectsExportExcelMax, subjectsExportCsvMax: s.data.subjectsExportCsvMax } }));
                else {
                    this.setState(state => ({
                        error: { exception: s.data.exception, exceptionData: s.data.exceptionData },
                        portfolios: { ...state.portfolios, loading: false, data: [] }
                    }));
                }
            },
            _ => {
                this.setState(
                    state => ({ portfolios: { ...state.portfolios, ...{ loading: false, error: this.props.translate('Common.Error') } } })
                );
            }
        );
    }

    deletePorfolioConfirm = (id, name) => {
        this.props.showPopup("confirmationPopup", {
            title: this.props.translate("Monitoring.Overview.DeleteItemsPermanentlyTitle"),
            htmlBody: this.props.translate("Monitoring.Overview.DeleteItemsPermanentlyBody").replace("{0}", name),
            yesButtonText: this.props.translate("Common.Button.Delete"),
            yesButtonFunction: () => {
                this.props.hidePopup();
                this.setState({ isLoading: true });
                this.props.deletePortfolio(id,
                    (s) => {
                        if (s.data.isSuccess) {
                            var data = this.state.portfolios.data.filter((d) => d.id !== id && d.parentId !== id);
                            var portfolios = this.state.portfolios;
                            portfolios.data = data;
                            this.setState({ portfolios: portfolios, isLoading: false, succRemoveMessage: name, error: null });
                        } else
                            this.onError(s.data.exception, s.data.exceptionData, "succRemoveMessage");
                    },
                    (e) => this.onError(e.data.error.message || "Common.Error", null, "succRemoveMessage")
                );
            },
            noButtonText: this.props.translate("Common.Button.Cancel"),
            open: true,
            close: () => this.props.hidePopup()
        });
    }

    onError = (exception, exceptionData = null, operation = "succOperationMessage") => {
        this.setState({
            isLoading: false,
            [operation]: false,
            error: { exception: exception, exceptionData: this.getExceptionData(exceptionData) }
        });
    }

    getExceptionData = (e) => isNullOrUndefined(e) ? undefined : e;
}

export default connect(
    state => ({ ...state.domain, user: state.userContext }),
    dispatch => bindActionCreators({ ...domainActions, ...layoutActions, ...popupActions, ...monitoringActions }, dispatch)
)(withLocalize(withRouter(PortfolioOverview)));